import type { TMargemParams, TMargem, TMargemParamsKeys } from '@/features/simulador/shared/types/margem.types'
import type { TModoDeLucroDaEmpresa } from '@/types/simulacao'

export type ParamsEntries = [TMargemParamsKeys, number]

export class CalculadoraDeMargem {
  calcularMargemBrutaEmUPF(valorTotalMedioUPF: number, custoUnidadeUPF: number): number {
    return valorTotalMedioUPF - custoUnidadeUPF
  }

  calcularMargemLiquidaEmUPF(
    margemBrutaEmUPF: number,
    patrimonioAfetacao: boolean,
    modoDeLucroDaEmpresa: TModoDeLucroDaEmpresa | 'NaoDefinido',
    percentualIRPJ = 0,
  ): number {
    if (modoDeLucroDaEmpresa === 'RealEstimado' && !patrimonioAfetacao) {
      const taxaIRPJ = percentualIRPJ / 100
      const margem = margemBrutaEmUPF - margemBrutaEmUPF * taxaIRPJ
      return margem
    }
    return margemBrutaEmUPF
  }

  calcularMargemRealizada(margemLiquidaEmUPF: number, params: TMargemParams): TMargem[] {
    const converterParamsParaListaDeMargens = (): TMargem[] => {
      const entries = Object.entries(params) as ParamsEntries[]
      return entries.map(([key, value]): TMargem => ({ tipo: key, margemAPI: value }))
    }

    const margens = converterParamsParaListaDeMargens()
    return margens.map((margem) => ({
      ...margem,
      margemPositiva: Math.abs(margem.margemAPI),
      margemRealizada: margem.margemAPI < 0 ? margemLiquidaEmUPF - margem.margemAPI : margemLiquidaEmUPF,
    }))
  }

  calcularPorcentagemMargemDeVenda(margemLiquidaEmUPF: number, valorPresentePontoMedioUPF: number): number {
    if (!valorPresentePontoMedioUPF) return 0
    return (margemLiquidaEmUPF / valorPresentePontoMedioUPF) * 100
  }
}
